import React from "react";
import NewsContainersOutcomesItems from "./NewsContainersOutcomesItems";

const NewsContainersOutcomesFun = ({ title }) => {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.05)",
        padding: "15px",
        borderRadius: "8px",
        border: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <h3
        style={{
          color: "white",
          marginTop: 0,
          marginBottom: "15px",
          textTransform: "capitalize",
          fontSize: "1.1rem",
          letterSpacing: "1px",
        }}
      >
        {title}
      </h3>

      {/* 3x3 CSS Grid Container */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "8px",
          width: "100%",
          aspectRatio: "1 / 1", // Forces the container to be a perfect square
          background: "rgba(0,0,0,0.2)",
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        {/* Generates exactly 9 squares */}
        {Array.from({ length: 9 }).map((_, index) => (
          <NewsContainersOutcomesItems key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default NewsContainersOutcomesFun;
